import { z } from 'zod';

export const alterCodeType = z.object({
  id: z.string(),
  prefixIncluded: z.boolean(),
  hasMixInformation: z.boolean(),
  eType: z.number(),
  isActive: z.boolean().optional(),
  isFromManager: z.boolean().optional(),
  code: z.string().optional(),
  name: z.string().optional(),
});

export const getAlterCodeTypesSchema = z.array(alterCodeType);

export type GetAlterCodeTypesResponse = z.infer<typeof getAlterCodeTypesSchema>;
